import React, { FC } from "react";

/**
 * The download menu's own glyph set — Lucide geometry, inline, `currentColor`
 * only. Local to this folder rather than borrowed from the video page's panel
 * icons: this component is now shared app-wide, so it should not reach into a
 * page's internals for its artwork.
 */
const svg =
  (inner: string): FC<{ size?: number; strokeWidth?: number }> =>
  ({ size = 17, strokeWidth = 1.7 }) =>
    (
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: inner }}
      />
    );

export const GlyphFilm = svg('<rect x="2" y="6" width="14" height="12" rx="2"/><path d="m17 10 5-2v8l-5-2z"/>');
export const GlyphZap = svg('<path d="M13 2 3 14h7l-1 8 10-12h-7z"/>');
export const GlyphCirclePlus = svg('<circle cx="12" cy="12" r="9"/><path d="M8 12h8M12 8v8"/>');
export const GlyphShield = svg('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>');
export const GlyphImage = svg(
  '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
);
export const GlyphFileText = svg(
  '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/>',
);
export const GlyphFolderDown = svg(
  '<path d="M21 8v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2z"/><line x1="12" y1="11" x2="12" y2="16"/><polyline points="9.5 13.5 12 16 14.5 13.5"/>',
);
export const GlyphDownload = svg(
  '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>',
);
export const GlyphComment = svg(
    '<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.4 8.4 0 0 1-3.8-.9L3 21l2-4.6A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z"/>',
);
export const GlyphChevronDown = svg('<polyline points="6 9 12 15 18 9"/>');
export const GlyphChevronUp = svg('<polyline points="18 15 12 9 6 15"/>');
